import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import AnimatedTextInput from "../../components/animatedTextInput";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function BodyDimensionsStep({ initState = null, onSubmitHandler, qKey }) {
  const { handleStep, previousStep, nextStep } = useWizard();
  const [bodyDim, setBodyDim] = useState(
    initState || { height: "", weight: "" }
  );
  const { t } = useTranslation();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setBodyDim((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const next = () => {
    const response = {
      _state: bodyDim,
      formatted_response: [
        {
          type: "TEXT",
          question: "What is your height?",
          code: "Q1",
          response: bodyDim["height"],
        },
        {
          type: "TEXT",
          question: "What is your weight?",
          code: "Q2",
          response: bodyDim["weight"],
        },
      ],
    };
    onSubmitHandler({ [qKey]: response });
    nextStep();
  };

  const inputMissing = () => !(bodyDim.height && bodyDim.weight);

  return (
    <div>
      <NavigateBackWizardStep
        clickHandler={previousStep}
        title={t("hi.title")}
        hideLibrary={true}
      />
      <>
        <div className="body_content py-5">
          <div className="inner_body ">
            <div className="fill_form light_fill_form">
              <h3 className="headtitle mb-4">{t("Q1.question")}</h3>
              <AnimatedTextInput
                label="cm"
                value={bodyDim.height}
                onChange={handleChange}
                id="height"
                isFocused={true}
              />
              <h3 className="headtitle mb-4">{t("Q2.question")}</h3>
              <AnimatedTextInput
                label="kg"
                value={bodyDim.weight}
                onChange={handleChange}
                id="weight"
              />
              <div className="btn_block d-flex justify-content-center bottom_button">
                <button
                  className="btn btn_primary"
                  disabled={inputMissing()}
                  onClick={() => next()}
                >
                  {t("login.DOBSTEP.button")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default BodyDimensionsStep;
